import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {CustomDateFieldComponent} from "./custom-date-field.component";
import {SummaryFieldModule} from "../../../../../modules/core/component/summary-field/summary-field.module";
import {MomentPipeModule} from "../../../../../modules/core/pipe/moment.pipe";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
        MomentPipeModule,
    ],
    declarations: [
        CustomDateFieldComponent,
    ],
    exports: [
        CustomDateFieldComponent,
    ],
})
export class CustomDateFieldModule {}
